import { colorsPalettes } from "@similarweb/styles";

export const circularLoaderoptions = {
    svg: {
        stroke: colorsPalettes.carbon[100],
        strokeWidth: "4",
        r: 21,
        cx: "50%",
        cy: "50%",
    },
    style: {
        width: 46,
        height: 46,
    },
};

export const SEGMENTS_LIMIT_STATUS_MAP = {
    IN_LIMIT: "WithinTheLimit",
    HARD_LIMIT: "HardLimitExceed",
    SOFT_LIMIT: "SoftLimitExceed",
};
